import { Col, Row } from "antd";
import React, { useCallback } from "react";
import { AiOutlineFile, AiOutlineFileJpg, AiOutlineFilePdf, AiOutlineMail } from "react-icons/ai";
import { trackPromise } from "react-promise-tracker";
import { useCommonStore } from "../../../../../stores/CommonStore";
import { fileFormat } from "../../../../../utils/app-common";
import { SiJpeg } from "react-icons/si";

const ManifestImageComponent = ({ list }: { list: unknown[] | unknown }) => {

    const DownloadManifestFilesAction = useCommonStore(state => state.DownloadManifestFilesAction);


    const DownloadFilesHandler = useCallback(
        (id: number, fileType: string, fileFormat: string) => {
            trackPromise(DownloadManifestFilesAction(id, fileType, fileFormat), 'download-file-area');
        },
        [DownloadManifestFilesAction],
    )
    const fileImage: { [key: string]: JSX.Element } = {
        pdf: <AiOutlineFilePdf size={30} />,
        jpeg: <AiOutlineFileJpg size={30} />,
        png: <SiJpeg size={30} />,
        rfc822: <AiOutlineMail size={30} />
    }

    const onFileDownloadHandler = useCallback((item: any) => {
        DownloadFilesHandler(item?.id, item?.fileType, fileFormat[item?.fileType]);
    }, [DownloadFilesHandler]);

    return (
        <>
            {
                Array.isArray(list) ? list.map((item) => {
                    return (
                        <React.Fragment key={item?.id} >
                                <Row gutter={[30,30]} justify="space-between" wrap>
                                    <Col span={24}>

                                            <div onClick={() => onFileDownloadHandler(item)} className={'pointer'} title={item?.fileName} >
                                                {fileImage[item?.fileType] || <AiOutlineFile size={30}></AiOutlineFile>}
                                            </div>
                                    </Col>
                                </Row>
                        </React.Fragment>
                    )
                })
                    : null}

        </>
    )
}

export default ManifestImageComponent